import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useEffect, useCallback } from 'react';
import { find } from 'lodash';
import { isFunction, addOrRemove } from '@elliemae/ds-utilities/utils';
import { RemovablePill } from '../RemovablePill.js';
import { Pill } from '../Pill.js';
import { OverflowPill } from '../OverflowPill.js';
import { DropdownPill } from '../DropdownPill.js';
import 'react-desc';
import '@elliemae/ds-icons/CloseXsmall';
import '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import '@elliemae/ds-classnames';
import '@elliemae/ds-tooltip';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-icons/ChevronDown';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function LabeledDropdownMultiPills(_ref) {
  var label = _ref.label,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {
    return null;
  } : _ref$onSelect,
      _ref$onRemove = _ref.onRemove,
      onRemove = _ref$onRemove === void 0 ? function () {
    return null;
  } : _ref$onRemove,
      onChange = _ref.onChange,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      menuProps = _objectWithoutProperties(_ref, ["label", "options", "value", "onSelect", "onRemove", "onChange", "maxWidth", "minWidth"]);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      totalDefaultOptions = _useState2[0],
      setTotalDefaultOptions = _useState2[1];

  var _useState3 = useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedOptions = _useState4[0],
      setSelectedOptions = _useState4[1];

  var _useState5 = useState(options),
      _useState6 = _slicedToArray(_useState5, 2),
      allOptions = _useState6[0],
      setAllOptions = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      overflowOptions = _useState8[0],
      setOverflowOptions = _useState8[1];

  var overflowQuantity = 3;
  useEffect(function () {
    return setSelectedOptions(value);
  }, [value]);
  useEffect(function () {
    var newOptions = allOptions.filter(function (option) {
      return option.fixedItem;
    });

    if (newOptions.length > 0) {
      setSelectedOptions(newOptions);
    }

    setTotalDefaultOptions(newOptions.length);
  }, []);
  useEffect(function () {
    if (totalDefaultOptions) {
      var newOptions = allOptions.map(function (opt) {
        if (selectedOptions.length <= totalDefaultOptions && find(selectedOptions, {
          id: opt.id
        })) {
          return _objectSpread(_objectSpread({}, opt), {}, {
            fixedItem: true
          });
        }

        return _objectSpread(_objectSpread({}, opt), {}, {
          fixedItem: false
        });
      });
      setAllOptions(newOptions);
    }
  }, [onSelect, onRemove, selectedOptions]);
  useEffect(function () {
    if (selectedOptions.length > overflowQuantity) {
      var overflow = selectedOptions.filter(function (val, index) {
        return index >= overflowQuantity;
      });
      setOverflowOptions(overflow);
    }
  }, [selectedOptions]);
  var selectOption = useCallback(function (option) {
    if (!option.fixedItem) {
      if (isFunction(onChange)) {
        var nextValue = addOrRemove(selectedOptions, option, function (item) {
          return item.id;
        });
        setSelectedOptions(nextValue);
        onChange(nextValue);
      }

      onSelect(option);
    }
  }, [selectedOptions]);
  var removeOption = useCallback(function (option) {
    if (!option.fixedItem || selectedOptions.length > totalDefaultOptions) {
      if (isFunction(onChange)) {
        var nextValue = selectedOptions.filter(function (val) {
          return option.id !== val.id;
        });
        setSelectedOptions(nextValue);
        onChange(nextValue);
      }

      onRemove(option);
    }
  }, [selectedOptions]);

  var typeOfPill = function typeOfPill() {
    if (selectedOptions.length > totalDefaultOptions) {
      return RemovablePill;
    }

    return Pill;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownPill, _extends({}, menuProps, {
    focusOnOpen: false,
    label: label,
    maxWidth: maxWidth,
    minWidth: minWidth,
    onSelectMenuItem: selectOption,
    options: [_objectSpread(_objectSpread({}, menuProps), {}, {
      type: 'SelectionGroup',
      id: 'multi-selection-views',
      multi: true,
      items: allOptions
    })],
    selection: {
      'multi-selection-views': selectedOptions ? selectedOptions.map(function (o) {
        return o.id;
      }) : ''
    },
    variant: "title"
  })), selectedOptions && selectedOptions.map(function (option, index) {
    var TypeOfPill = typeOfPill();

    if (index < overflowQuantity) {
      return /*#__PURE__*/React.createElement(TypeOfPill, {
        key: option.id,
        label: option.label,
        onRemove: function onRemove() {
          return removeOption(option);
        }
      });
    }

    return null;
  }), selectedOptions && selectedOptions.length > overflowQuantity && /*#__PURE__*/React.createElement(OverflowPill, {
    label: "+ ".concat(selectedOptions.length - overflowQuantity),
    options: overflowOptions
  }));
}

export default LabeledDropdownMultiPills;
//# sourceMappingURL=LabeledDropdownMultiPill.js.map
